import { backend_api } from "../../../../../static/server";

const defaultSections = [
  {
    id: 0,
    name: "Matter Details",
    section_name: "section_1",
    columns: 3,
    alignment: "top_to_bottom",
    isEditableSection: false,
    fields: [
      {
        id: 0,
        position_index: 0,
        name: "case_related_person",
        type: "field",
        label: "Client",
        required: true,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Select the client this matter is related to. This is a required field.",
        isEditable: false,
        pickList: {
          multiSelect: false,
          defaultValue: "none",
          link_option: {
            tab: "contact",
            tab_api: `${backend_api}contact/retrieve/`,
          },
        },
      },
      {
        id: 1,
        position_index: 1,
        name: "client_ref",
        type: "field",
        label: "Matter-Ref ID",
        required: true,
        field_type: "single_line",
        value: "single_line",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Enter a unique reference ID for this matter. This value must be unique and defined by you — duplicate references are not allowed.",
        isEditable: false,
      },
      {
        id: 2,
        position_index: 2,
        name: "case_name",
        type: "field",
        label: "Matter Name",
        required: true,
        field_type: "single_line",
        value: "single_line",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Enter a descriptive name for this matter to easily identify it later.",
        isEditable: false,
        characterLimit: 255,
      },
      {
        id: 3,
        position_index: 3,
        name: "case_status",
        type: "field",
        label: "Matter Status",
        required: true,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Track the current status of the matter (e.g., Open, Pending, Closed).",
        isEditable: false,
        pickList: {
          multiSelect: false,
          defaultValue: "open",
          useColors: true,
          options: [
            { label: "Open", value: "open", color: "#34D399" },
            { label: "Pending", value: "pending", color: "#FBBF24" },
            { label: "Closed", value: "closed", color: "#F97316" },
          ],
        },
      },
      {
        id: 6,
        position_index: 4,
        name: "open_date",
        type: "field",
        label: "Opening Date",
        required: false,
        field_type: "date",
        value: "date",
        isNew: true,
        tooltip: true,
        tooltipText: "Date when this matter was officially opened.",
        isEditable: false,
      },
      {
        id: 4,
        position_index: 5,
        name: "case_responsible_attorney",
        type: "field",
        label: "Responsible Attorney",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Select the person responsible for handling this matter. This can be an attorney, paralegal, or any staff member assigned access to manage casework.",
        isEditable: false,
        pickList: {
          multiSelect: false,
          defaultValue: "option_1",
          link_option: {
            tab: "member",
            tab_api:
              `${backend_api}team/create-employee/?is_active=True`,
          },
        },
      },
      {
        id: 5,
        position_index: 6,
        name: "case_originating_attorney",
        type: "field",
        label: "Originating Attorney",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Select the person who brought the client or matter to the firm.",
        isEditable: false,
        pickList: {
          multiSelect: false,
          defaultValue: "option_1",
          link_option: {
            tab: "member",
            tab_api:
              `${backend_api}team/create-employee/?is_active=True`,
          },
        },
      },
      {
        id: 7,
        position_index: 7,
        name: "access_users",
        type: "field",
        label: "Access Members",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        tooltip: true,
        tooltipText:
          "Select team members who can access this matter. Only selected users will be able to view and work on this matter.",
        isEditable: false,
        pickList: {
          multiSelect: true,
          defaultValue: [],
          link_option: {
            tab: "member",
            tab_api:
              `${backend_api}team/create-employee/?is_active=True`,
          },
        },
      },
    ],
  },
  {
    id: 1,
    name: "Billing preferences",
    section_name: "section_2",
    columns: 3,
    alignment: "top_to_bottom",
    isEditableSection: false,
    fields: [
      {
        id: 0,
        position_index: 0,
        name: "billable",
        type: "field",
        label: "This matter is billable",
        required: false,
        field_type: "check_box",
        value: "check_box",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText:
          "Mark if this matter should be tracked for billing purposes.",
      },
      {
        id: 1,
        position_index: 1,
        name: "currency",
        type: "field",
        label: "Currency",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Select currency for billing in this matter",
        pickList: {
          multiSelect: false,
          defaultValue: "USD",
          options: [],
        },
      },
      {
        id: 2,
        position_index: 2,
        name: "billable_method",
        type: "field",
        label: "Billing Method",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Specify how billing will be calculated for this matter.",
        pickList: {
          multiSelect: false,
          defaultValue: "hourly",
          options: [
            { label: "Hourly", value: "hourly" },
            { label: "Flat Fee", value: "flat_rate" },
            { label: "Contingency Fee", value: "contingency" },
          ],
        },
      },
      {
        id: 3,
        position_index: 3,
        name: "bill_case_contacts",
        type: "field",
        label: "Select Member(s)",
        required: false,
        field_type: "pick_list",
        value: "pick_list",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText:
          "Choose who should be billed or associated with billing tasks.",
        pickList: {
          multiSelect: false,
          defaultValue: "option_1",
          link_option: {
            tab: "member",
            tab_api:
              `${backend_api}team/create-employee/?is_active=True`,
          },
        },
      },
      {
        id: 4,
        position_index: 4,
        name: "hourly_rate",
        type: "field",
        label: "Hourly Rate",
        required: false,
        field_type: "currency",
        value: "currency",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Enter the hourly billing rate for this matter.",
      },
      {
        id: 5,
        position_index: 5,
        name: "flat_rate",
        type: "field",
        label: "Flat Rate",
        required: false,
        field_type: "currency",
        value: "currency",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Set the total flat fee charged for this matter.",
      },
      {
        id: 6,
        position_index: 6,
        name: "contingency_rate",
        type: "field",
        label: "Contingency Rate",
        required: false,
        field_type: "percent",
        value: "percent",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText:
          "Specify the percentage fee collected from client award or recovery.",
      },
      {
        id: 7,
        position_index: 7,
        name: "set_case_budget",
        type: "field",
        label: "Set matter budget",
        required: false,
        field_type: "check_box",
        value: "check_box",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Enable budget tracking for this matter.",
      },
      {
        id: 8,
        position_index: 8,
        name: "budget",
        type: "field",
        label: "Budget amount",
        required: false,
        field_type: "currency",
        value: "currency",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText: "Enter the total budgeted cost for handling this matter.",
      },
      {
        id: 9,
        position_index: 9,
        name: "include_expense",
        type: "field",
        label: "Include expenses",
        required: false,
        field_type: "check_box",
        value: "check_box",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText:
          "Check if reimbursable expenses should be included in billing.",
      },
      {
        id: 10,
        position_index: 10,
        name: "low_budget_notificatoin",
        type: "field",
        label: "Notify client fund low",
        required: false,
        field_type: "check_box",
        value: "check_box",
        isNew: true,
        isEditable: false,
        tooltip: true,
        tooltipText:
          "Enable notifications when client balance drops below threshold.",
      },
    ],
  },
];

export default defaultSections;
